import { render, staticRenderFns } from "./RemoteMonitoringTasks.vue?vue&type=template&id=ba565f78"
import script from "./RemoteMonitoringTasks.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports